import type { Bcp47Locale } from '@backmarket/core-types/Locale'

/**
 * Converts a locale string into a standardized BCP 47 format.
 *
 * @example "en_US" => "en-us"
 * @example "zh-Hans" => "zh-hans"
 */
export function toBcp47Locale(locale: string): Bcp47Locale {
  // `language` should be a 2-letter ISO 639-1 code (e.g., "en", "fr", "zh")
  // `languageCountryOrScript` should be either:
  //   - 2 letters: ISO 3166-1 alpha-2 country code (e.g., "US", "FR")
  //   - 4 letters: ISO 15924 script code (e.g., "HANS", "HANT")
  const match = locale.match(
    /^(?<language>[a-zA-Z]{2}).(?<languageCountryOrScript>[a-zA-Z]{2,4})$/,
  )

  if (
    !match?.groups ||
    !match.groups.language ||
    !match.groups.languageCountryOrScript
  ) {
    throw new Error(`Invalid locale: ${locale}`)
  }

  const { language, languageCountryOrScript } = match.groups

  return `${language.toLowerCase()}-${languageCountryOrScript.toLowerCase()}` as Bcp47Locale
}
